import { render, staticRenderFns } from "./CallsDialog.vue?vue&type=template&id=24ea6cf2&"
import script from "./CallsDialog.vue?vue&type=script&lang=js&"
export * from "./CallsDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports